/*
 * @Date: 2021-05-12 09:29:36
 */
import { mapGetters, mapMutations } from 'vuex'

let themeMixin = {
  computed: {
    ...mapGetters([
      'getCurThemeType'
    ]),
  },

  methods: {
    ...mapMutations([
      'setCurThemeType'
    ])
  },
	

}
export default themeMixin;